﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorStatsCollectorABI = void 0;
class ValidatorStatsCollectorABI {
    static GetABI() {
        return [
            {
                "inputs": [
                    {
                        "internalType": "address",
                        "name": "manager_",
                        "type": "address"
                    }
                ],
                "stateMutability": "nonpayable",
                "type": "constructor"
            },
            {
                "inputs": [],
                "name": "currentStat",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "timestamp",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "acc",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "profitPerValidator",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "skip",
                        "type": "uint256"
                    }
                ],
                "name": "getStatsFromEnd",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "length",
                        "type": "uint256"
                    },
                    {
                        "components": [
                            {
                                "internalType": "uint256",
                                "name": "timestamp",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "acc",
                                "type": "uint256"
                            },
                            {
                                "internalType": "uint256",
                                "name": "profitPerValidator",
                                "type": "uint256"
                            }
                        ],
                        "internalType": "struct StatsCollector.StatData[52]",
                        "name": "list",
                        "type": "tuple[52]"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "manager",
                "outputs": [
                    {
                        "internalType": "address",
                        "name": "",
                        "type": "address"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [],
                "name": "totalIncome",
                "outputs": [
                    {
                        "internalType": "uint256",
                        "name": "",
                        "type": "uint256"
                    }
                ],
                "stateMutability": "view",
                "type": "function"
            },
            {
                "inputs": [
                    {
                        "internalType": "uint256",
                        "name": "income",
                        "type": "uint256"
                    },
                    {
                        "internalType": "uint256",
                        "name": "validatorsCount",
                        "type": "uint256"
                    }
                ],
                "name": "update",
                "outputs": [],
                "stateMutability": "nonpayable",
                "type": "function"
            }
        ];
    }
}
exports.ValidatorStatsCollectorABI = ValidatorStatsCollectorABI;
//# sourceMappingURL=ValidatorStatsCollectorABI.js.map